
    export enum EnumConfidential {
			NotConfidential = 1,
			UkdOnlyButNotPublicUkd = 2,
			SomeOfTheCompanysProductsAreConfidentialAndSomeAreNot = 3,
			Confidential = 4,
    }